import gql from 'graphql-tag';

export const QueryV1 = gql`
  query solo_J1QL(
    $query: String!
    $variables: JSON
    $dryRun: Boolean
    $remember: Boolean
    $includeDeleted: Boolean
    $flags: QueryV1Flags
    $cursor: String
  ) {
    queryV1(
      query: $query
      variables: $variables
      dryRun: $dryRun
      remember: $remember
      includeDeleted: $includeDeleted
      flags: $flags
      cursor: $cursor
    ) {
      type
      data
      cursor
    }
  }
`;

export const DeferredJ1QL = gql`
  query solo_DeferredJ1QL(
    $query: String!
    $variables: JSON
    $remember: Boolean
    $deferredFormat: DeferredResponseFormat
    $flags: QueryV1Flags
    $includeDeleted: Boolean
    $cursor: String
  ) {
    queryV1(
      query: $query
      variables: $variables
      deferredResponse: FORCE
      remember: $remember
      deferredFormat: $deferredFormat
      flags: $flags
      includeDeleted: $includeDeleted
      cursor: $cursor
    ) {
      type
      url
      cursor
    }
  }
`;

export const QueryV1InStandard = gql`
  query QueryV1InStandard(
    $query: String!
    $cursor: String
    $variables: JSON
    $standardId: ID!
  ) {
    queryV1InStandard(
      query: $query
      cursor: $cursor
      variables: $variables
      standardId: $standardId
    ) {
      type
      data
      cursor
    }
  }
`;

export const ListCollectionResults = gql`
  query ListCollectionResults(
    $collectionType: CollectionType!
    $collectionOwnerId: String!
    $beginTimestamp: Long!
    $endTimestamp: Long!
    $limit: Int
    $cursor: String
  ) {
    listCollectionResults(
      collectionType: $collectionType
      collectionOwnerId: $collectionOwnerId
      beginTimestamp: $beginTimestamp
      endTimestamp: $endTimestamp
      limit: $limit
      cursor: $cursor
    ) {
      results {
        timestamp
        outputs {
          name
          value
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GetSettings = gql`
  query GetSettings(
    $resourceType: String!
    $category: String!
    $resourceId: String
  ) {
    getSettings(
      resourceType: $resourceType
      category: $category
      resourceId: $resourceId
    ) {
      category
      data
    }
  }
`;

export const SetSettings = gql`
  mutation SetSettings(
    $resourceType: String!
    $category: String!
    $data: JSON
  ) {
    setSettings(resourceType: $resourceType, category: $category, data: $data) {
      resultCode
    }
  }
`;

export const GetDashboardQuestionWidgetData = gql`
  query GetDashboardQuestionWidgetData(
    $dashboardId: String!
    $widgetId: String!
    $dashboardType: DashboardType!
    $beginTimestamp: Long!
    $endTimestamp: Long!
    $ownerId: String!
  ) {
    getDashboardQuestionWidgetData(
      dashboardId: $dashboardId
      widgetId: $widgetId
      dashboardType: $dashboardType
      beginTimestamp: $beginTimestamp
      endTimestamp: $endTimestamp
      ownerId: $ownerId
    ) {
      dashboardId
      widgetId
      data {
        results
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

export const GetDashboardWidgetSettings = gql`
  query GetDashboardWidgetSettings(
    $dashboardId: String!
    $dashboardType: DashboardType!
    $ownerId: String!
  ) {
    getDashboardWidgetSettings(
      dashboardId: $dashboardId
      dashboardType: $dashboardType
      ownerId: $ownerId
    ) {
      dashboardId
      data
    }
  }
`;
